import React, { Component } from 'react';
import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead, MDBBtn } from 'mdbreact';
import { tableColumns } from './constant.js';
import AddCustomerModal from './modal/modal.js';

class Customer extends Component {
  //If id === undefined => post else put
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      presentedArray: [],
      modal: false,
      modalContent: {
        _id: undefined,
        customerName: '',
        email: '',
        phoneNumber: '',
        address: ''
      }
    }
  }

  componentDidMount() {
    this.fetchAllCustomer((customers) => {
      this.setState({customers: customers});
    });
  }

  //for modal
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
      modalContent: {
        _id: undefined,
        customerName: '',
        email: '',
        phoneNumber: '',
        address: ''
      }
    });
  }

  fetchAllCustomer(callback) {
    fetch(`${global.gConfig.backend.url}/api/v1/customer`)
      .then( res => res.json())
      .then( customers => {
        callback(customers);
      })
  }

  onCustomerClick(customer) {
    this.setState({
      modal: !this.state.modal,
      modalContent: {
        _id: customer._id,
        customerName: customer.customerName,
        email: customer.email,
        phoneNumber: customer.phoneNumber,
        address: customer.address
      }
    })
  }

  afterPostCustomer = ( customer ) => {
    let newCustomers = this.state.customers;
    newCustomers.push(customer[0]);
    this.setState({customers: newCustomers})
  }

  afterPutCustomer = ( customer ) => {
    let index = this.state.customers.findIndex((value, index, array) => {
      return value._id === customer._id;
    })

    let newCustomers = this.state.customers;
    newCustomers[index] = customer;

    this.setState({customers: newCustomers})
  }

  render() {
    const { customers, modal, modalContent} = this.state;
    return (
      <MDBContainer fluid>
        <MDBBtn rounded outline size="sm" onClick={this.toggle} style={{marginBottom: "1rem"}}>Add New Customer</MDBBtn>
        { modal ? (
            <AddCustomerModal
              modal={modal}
              toggle={this.toggle}
              modalContent={modalContent}
              afterPostCustomer={this.afterPostCustomer}
              afterPutCustomer={this.afterPutCustomer}
            />
          ) : null
        }
        <MDBTable hover>
          <MDBTableHead color="primary-color" textWhite  columns={tableColumns}/>
          <MDBTableBody>
            {customers.map((value, index) => {
              return (
                <tr key={value._id} onClick={() => {this.onCustomerClick(value)}}>
                  <td>{value.customerName}</td>
                  <td>{value.email}</td>
                  <td>{value.phoneNumber}</td>
                  <td>{value.address}</td>
                </tr>
              );
            })}
          </MDBTableBody>
        </MDBTable>
      </MDBContainer>
    );
  }
}

export default Customer;
